export default __webpack_public_path__ + "static/media/tv_interview.fdcbad9a.png";